// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"CollectionContextMenu_dropdown__3r5ku","ellipsis":"CollectionContextMenu_ellipsis__wO-mc"};